<template>
  <v-container fluid>
    <Window
      v-model="record_id"
      name="Verbale TERRE"
      ref="window"
      v-on:save="onSave"
      @change="onChange"
    ></Window>
    <br />
    <v-flex d-flex>
      <v-btn text :disabled="!record_id" @click="downloadVerbale"
        ><v-icon>mdi-download</v-icon>Download Verbale</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn text color="error" @click="close">Chiudi</v-btn>
    </v-flex>
  </v-container>
</template>

<script>
/*eslint-disable */
import Window from "../components/Window.vue";
import mixin from "../mixin/MixingCommonComp";

export default {
  mixins: [mixin],
  components: { Window },
  data() {
    return {
      ad_window_id: 1000075,
      record_id: 0,
    };
  },
  methods: {
    close() {
      this.$router.push({ path: "/" });
    },
    downloadVerbale() {
      console.log("downloadVerbale");
      this.$store.commit("setProgressMessage", "Download in corso");
      this.$store.commit("setProgressLoading", true);
      let parameters = {};
      parameters.idempiereRestPath = "print/addPrintJob";
      let data = {};
      data.parameters = "{id:" + this.record_id + "}";
      data.nomeStampa = "Verbale TERRE";
      parameters.data = data;
      this.$store.dispatch("callIdempiereRest", parameters).then((response) => {
        if (response.data.hasOwnProperty("file")) {
          const linkSource =
            "data:application/pdf;base64," + response.data.file;
          const downloadLink = document.createElement("a");
          const fileName = this.$refs.window.getValue("nomeverbale") + ".pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.$store.commit("setProgressMessage", null);
        } else {
          this.$store.commit("setProgressMessage", null);
          var errorMsg = "Download non riuscito";
          if (response.data.hasOwnProperty("message")) {
            errorMsg = errorMsg + "\n" + response.data.message;
          }
          this.$store.commit("setErrorMessage", errorMsg);
        }
      });
    },
    createAssetVerbaleTerre() {
      let parameters = {};
      parameters.data = { fct_verbaleterre_id: this.record_id };
      parameters.idempiereRestPath = "vecos/createAssetVerbaleTerre";
      this.$store.dispatch("callIdempiereRest", parameters).then((response) => {
        if (response.data.result == "OK") {
          this.$refs.window.getData();
        }
      });
    },
    onSave(success) {
      if (success) {
        if (this.$store.state.datiVerbale.isBadPayer) {
          this.showInfoDialog(
            "Salvataggio eseguito! \n Il cliente è un cattivo pagatore"
          );
        } else {
          this.showSuccessDialog("Salvataggio eseguito!");
        }
      }
    },
    onChange(item) {
      if (item.field.Column.ColumnName == "Alimentazione") {
        if (item.value == "BT") {
          this.$refs.window.setValue("tensionealim", "0,40/0,23");
          this.$refs.window.setValue("CabinaTrasformazioneATMT", "N");
          this.$refs.window.setValue("CabinaTrasformazioneMTBT", "N");
        } else {
          this.$refs.window.setValue("CabinaTrasformazioneATMT", null);
          this.$refs.window.setValue("CabinaTrasformazioneMTBT", null);
        }
      } else if (item.field.Column.ColumnName == "TipoVerifica"){
        if(item.value == "S"){
          this.$refs.window.setValue("PeriodoVerifica", null);
        }
      }
    },
  },
  mounted() {
    let datiVerbale = this.$store.state.datiVerbale;
    this.record_id = datiVerbale.fct_verterre_id;

    setTimeout(async () => {
      while(!this.$refs.window.isDataFetched()){
        await new Promise(resolve => setTimeout(resolve, 1000));
      }

      this.$refs.window.setValue("C_BPartner_ID", datiVerbale.c_bpartner_id);
      this.$refs.window.setValue("C_OrderLine_ID", datiVerbale.c_orderline_id);
      this.$refs.window.setValue(
        "fct_scadverifiche_ID",
        datiVerbale.fct_scadverifiche_id
      );

      this.$refs.window.setCopyValue(
        "C_OrderLine_ID",
        datiVerbale.c_orderline_id
      );

      let parameters = {};
      parameters.data = { c_orderline_id: datiVerbale.c_orderline_id };
      parameters.idempiereRestPath = "vecos/getDatiImpiantoElettrico";
      let response = await this.$store.dispatch(
        "callIdempiereRest",
        parameters
      );

      let dati = response.data.dati;

      if (datiVerbale.type != "M") {
        let tipoVerifica = dati.tipoVerifica == "st" ? "S" : "P";
        let periodicitaVerifica = dati.tipoVerifica == "bi" ? "B" : "Q";
        this.$refs.window.setValue("TipoVerifica", tipoVerifica);
        if(tipoVerifica != "S"){
          this.$refs.window.setValue("PeriodoVerifica", periodicitaVerifica);
        }
        this.$refs.window.setValue("ambiente", dati.ambiente);
        this.$refs.window.setValue("comuneditta", dati.comuneDitta);
        this.$refs.window.setValue("viaditta", dati.viaDitta);

        if(datiVerbale.type == "N"){
          let osservazioni =
          "Ambiente e periodicità di verifica stabiliti dalla Committente\n" +
          "POD:" +
          dati.codicePOD;

          this.$refs.window.setValue("osservazioni", osservazioni);
        }
      }

      if (datiVerbale.type == "C") {
        if (this.$refs.window.getValue("Alimentazione") == "BT") {
          if (!this.$refs.window.getValue("tensionealim")) {
            this.$refs.window.setCopyValue("tensionealim", "0,40/0,23");
          }

          if (!this.$refs.window.getValue("CabinaTrasformazioneATMT")) {
            this.$refs.window.setCopyValue("CabinaTrasformazioneATMT", "N");
          }

          if (!this.$refs.window.getValue("CabinaTrasformazioneMTBT")) {
            this.$refs.window.setCopyValue("CabinaTrasformazioneMTBT", "N");
          }
        }

        if (!this.$refs.window.getValue("osservazioni")) {
          let osservazioni =
            "Ambiente e periodicità di verifica stabiliti dalla Committente\n" +
            "POD:" +
            dati.codicePOD;

          this.$refs.window.setCopyValue("osservazioni", osservazioni);
        }

        this.$refs.window.copyRecord();
      }
    }, 1000);
  },
  watch: {
    record_id: function () {
      let datiVerbale = this.$store.state.datiVerbale;
      datiVerbale.fct_verterre_id = this.record_id;
      this.$store.commit("setDatiVerbale", datiVerbale);

      this.createAssetVerbaleTerre();
    },
  },
};
</script>

<style>
</style>